<template>
  <MyManage>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="订单流水" name="mingxi" v-if="checkPermission(['bee:order:report:orderReportList'])">
        <MingxiPage v-if="activeName=='mingxi'"></MingxiPage>
      </el-tab-pane>

      <el-tab-pane label="结算单" name="settlement" v-if="checkPermission(['bee:sett:settlementOrder:report:pagerWithCondition'])">
        <SettlementPage v-if="activeName=='settlement'"></SettlementPage>
      </el-tab-pane>

      <el-tab-pane label="场站报表" name="stationOrder" v-if="checkPermission(['bee:order:report:stationDailyReport']) || checkPermission(['bee:order:report:stationMonthlyReport']) || checkPermission(['bee:order:report:stationYearlyReport'])">
        <StationOrderPage v-if="activeName=='stationOrder'"></StationOrderPage>
      </el-tab-pane>

      <el-tab-pane label="运营商报表" name="operstorOrder" v-if="checkPermission(['bee:order:report:operatorDailyReport']) || checkPermission(['bee:order:report:operatorMonthlyReport']) || checkPermission(['bee:order:report:operatorYearlyReport'])">
        <OperatorOrderPage v-if="activeName=='operstorOrder'"></OperatorOrderPage>
      </el-tab-pane>
    </el-tabs>

  </MyManage>
</template>

<script>
  import MingxiPage from '@/module/dataCenter/page/baobiao/mingxi/list.vue'
  import SettlementPage from '@/module/dataCenter/page/baobiao/settlementOrder/list.vue'
  import StationOrderPage from '@/module/dataCenter/page/baobiao/station/list.vue'
  import OperatorOrderPage from '@/module/dataCenter/page/baobiao/operatorOrder/list.vue'
  import MyManage from '@/components/MyManage'

  export default {
    name: 'manage',
    components: {
      MyManage,
      SettlementPage,
      StationOrderPage,
      OperatorOrderPage,
      MingxiPage
    },
    data() {
      return {
        activeName: 'mingxi',
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {
      handleClick(tab, event) {
        // console.log(this.activeName)
      }
    }
  }
</script>

<style>
  .el-dialog__header {
    text-align: center;
  }

  #manage .el-switch.is-disabled .el-switch__core, #manage .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/baobiao/manage.vue